import React, { useRef } from 'react';
import { useRemountOnPageHidden } from '../../hooks/useRemountOnPageHidden';
import { 
  IonContent, 
  IonCard, 
  IonCardHeader, 
  IonCardTitle,
  IonCardContent,
  IonIcon, 
  useIonRouter, 
  IonPage,
} from '@ionic/react';
import { calendar, person, settings, notifications } from 'ionicons/icons';
import { useAuth } from '../../contexts';
import styles from './Dashboard.module.scss';
import { useTranslation } from 'react-i18next';

const DashboardClient: React.FC = () => {
  const { t } = useTranslation();
  const router = useIonRouter();
  const { user } = useAuth();

  // The scrolling area is rebuilt while the page is hidden, so it is back at the top on return
  const scrollAreaRef = useRef<HTMLIonContentElement>(null);
  const scrollResetKey = useRemountOnPageHidden(scrollAreaRef);

  const goToBookings = () => {
    router.push('/tabs/bookingSystem/booking');
  };

  const goToProfile = () => {
    router.push('/dashboard/client/profile');
  };

  const goToAlerts = () => {
    router.push('/tabs/dashboard/client/alerts');
  };

  const goToSettings = () => {
    router.push('/dashboard/client/settings');
  };

  return (
    <div className={styles.loginContainer}>
        <IonPage className={styles.loginPage}>
      <IonContent key={scrollResetKey} ref={scrollAreaRef}>
        <div className={styles.dashboardContainer}>
          <div className={styles.cardRow}>
            <IonCard 
              className={styles.menuCard} 
              onClick={goToBookings}
              button={true}
            >
              <IonCardHeader className={styles.menuCardHeader}>
                <IonIcon icon={calendar} className={styles.menuIcon} />
                <IonCardTitle className={styles.menuTitle}>{t('pages.dashboard.DashboardClient.myBookings')}</IonCardTitle>
              </IonCardHeader>
            </IonCard>
            <IonCard className={styles.menuCard} onClick={goToProfile}>
              <IonCardHeader className={styles.menuCardHeader}>
                <IonIcon icon={person} className={styles.menuIcon} />
                <IonCardTitle className={styles.menuTitle}>{t('pages.dashboard.DashboardClient.profile')}</IonCardTitle>
              </IonCardHeader>
            </IonCard>
            <IonCard className={styles.menuCard} onClick={goToAlerts}>
              <IonCardHeader className={styles.menuCardHeader}>
                <IonIcon icon={notifications} className={styles.menuIcon} />
                <IonCardTitle className={styles.menuTitle}>{t('pages.dashboard.DashboardClient.alerts')}</IonCardTitle>
              </IonCardHeader>
            </IonCard>
            <IonCard className={styles.menuCard} onClick={goToSettings}>
              <IonCardHeader className={styles.menuCardHeader}>
                <IonIcon icon={settings} className={styles.menuIcon} />
                <IonCardTitle className={styles.menuTitle}>{t('pages.dashboard.DashboardClient.settings')}</IonCardTitle>
              </IonCardHeader>
              </IonCard>
          </div>  
          <IonCard className={styles.welcomeCard}>
            <IonCardHeader>
                  <IonCardTitle className={styles.welcomeTitle}>{t('pages.dashboard.DashboardClient.welcomeBack', { name: user?.name })}</IonCardTitle>
                </IonCardHeader>
                <IonCardContent className={styles.welcomeContent}>{t('pages.dashboard.DashboardClient.yourNextCleaningServiceIsScheduled')}
                  <strong>{t('pages.dashboard.DashboardClient.notScheduled')}</strong>
                  </IonCardContent>
          </IonCard>
        </div>
      </IonContent>
    </IonPage>
    </div>
  );
};

export default DashboardClient;
